import ProductDetails from "../../components/ProductDetails";

const ProductDetailsPage = () => {
  return (
    <div>
      <ProductDetails />
    </div>
  );
};

export default ProductDetailsPage;
